



































import { Component, Mixins } from "vue-property-decorator";
import { ReferenceCommentListTableMixin } from "./mixins";
import CommentTable from "./controles/CommentTable.vue";

@Component({
  components: {
    CommentTable,
  }
})
export default class ReferenceCommentListTable extends Mixins(ReferenceCommentListTableMixin) {
}
